{
  "name": "La primera cadena por montar",
  "commands": [
    { "type": "createRoute", "from": "mina", "to": "taller", "vehicle": "truck" },
    { "type": "createRoute", "from": "taller", "to": "almacen", "vehicle": "truck" }
  ]
}
